import { i18n } from '@/i18n';
import { getStore } from '@/store';

const loadForm = (formId) => getStore().dispatch('loadForm', formId);

/** This is to test if translation keys look like eg. 'tenant.2', in which case we do not want to translate them */
function isValidTranslationKey(key) {
  return typeof key !== 'string' || !/\.\d+$/.test(key);
}

const getDropdownOptions = (dropdownId, locale, params) => {
  let dropdownPromise;
  const translateIfTranslationExists = (key, defaultValue) => ((isValidTranslationKey(key) && i18n.te(key, locale)) ? i18n.t(key, locale) : defaultValue);
  if (!Array.isArray(dropdownId)) {
    dropdownPromise = getStore().dispatch('loadDropdown', {
      id: dropdownId,
      languageId: locale,
      refresh: false,
      params,
    });
  } else {
    dropdownPromise = Promise.all(dropdownId.map((id) => getStore().dispatch('loadDropdown', {
      id,
      languageId: locale,
      refresh: false,
      params,
    })))
      .then((dropdownOptions) => [].concat(...dropdownOptions));
  }
  return dropdownPromise
    .then((dropdownOptions) => dropdownOptions.map((option) => ({
      id: option.id,
      text: translateIfTranslationExists(option.id, option.text),
      properties: option.properties,
    })));
};

const getDropdownValue = (dropdownId, languageId, value) => getDropdownOptions(dropdownId, languageId).then((dropdownVals) => {
  if (value) {
    if (Array.isArray(value)) {
      let ret = '';
      value.forEach((val) => {
        const opt = dropdownVals.find((element) => element.id === val);
        const txt = opt ? opt.text : val;
        if (ret.length > 0) { ret = `${ret},${txt}`; } else { ret = txt; }
      });
      return ret;
    }
    const option = dropdownVals.find((element) => element.id === value);
    return option ? option.text : value;
  }
  return value;
});

const refreshDropdown = (dropdownId, locale) => getStore().dispatch('loadDropdown', {
  id: dropdownId,
  languageId: locale,
  refresh: true,
});

export {
  refreshDropdown, getDropdownOptions, loadForm, getDropdownValue,
};
